export default __webpack_public_path__ + "static/media/AliceMbah.0ed1d19c.svg";